import Box from '@mui/material/Box';
import CategoryFilter from './CategoryFilter';
import VisaFilter from './VisaFilter';

interface Props {
    isOpenDrawer: boolean;
}

const PublicFilter: React.FC<Props> = ({ isOpenDrawer }) => {
  return (
    <Box sx={{ px: 2 }}>
      <Box sx={{ mb: 3 }}>
        <VisaFilter />
      </Box>
      <Box>
        <CategoryFilter openDrawer={isOpenDrawer}/>
      </Box>
    </Box>
  );
};

export default PublicFilter;
